export default __webpack_public_path__ + "static/media/0148.8efef471.jpg";